export const MINIMUM_PHONE_NUMBER_LENGTH = 8; // country dialing code + 5 digit number
export const DEBOUNCE_TIME = 500;
